<template>
  <div class="top">
    <div class="flexbox">
      <div class="logo">
        <router-link to="/"><img src="../../assets/img/logo.png"></router-link>
      </div>
    </div>
  </div>
  <div class="flexbox loginmain">
    <div class="left"></div>
    <div class="right">
      <div v-if="false" class="flexbox tabtop">
        <div :class="tabidx == 0?'active': ''" @click="tabidx = 0">账号登录</div>
        <div :class="tabidx == 1?'active': ''" @click="tabidx = 1">短信登录</div>
      </div>
      <div class="tabcon">
        <!-- 账号登录 -->
        <div v-if="tabidx == 0" class="">
          <div class="inputbox">
            <el-input v-model="pnum" placeholder="请输入账号或手机号" prefix-icon="el-icon-user"></el-input>
          </div>
          <div class="inputbox">
            <el-input v-model="password" placeholder="请输入密码" prefix-icon="el-icon-lock" type="password"></el-input>
          </div>
          <div class="flexbox inputbox">
            <el-input v-model="verify" placeholder="请输入验证码" style="width: 200px;"
                      @keyup.enter="onSubmitUser"></el-input>
            <div class="code" @click="refreshCode">
              <img :src="codeimgSrc">
            </div>
          </div>
          <el-button stle="width: 100%;" type="primary" @click="onSubmitUser">登 录</el-button>
          <div class="swp">
            <router-link to="ForgetPassword">忘记密码</router-link>
          </div>
        </div>
        <!-- 短信登录 -->
        <div v-else v-if="false" class="shortmsg">
          <div class="inputbox">
            <el-input v-model="pnumb" placeholder="请输入手机号" prefix-icon="el-icon-lock"></el-input>
          </div>
          <div class="flexbox inputbox">
            <el-input v-model="codeb" placeholder="请输入验证码" @keyup.enter="onSubmitNum"></el-input>
            <el-button>获取验证码</el-button>
          </div>
          <el-button stle="width: 100%;" type="primary" @click="onSubmitNum">登 录</el-button>
        </div>
        <div class="loginway flexbox">
          <!-- <div class=""><img src="/static//img/weixinico.png">微信登录</div> -->
          <!-- <router-link to="/register"><img src="/static//img/jiantouico.png">快速注册</router-link> -->
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <p>Copyright© 2019 玫德集团有限公司 版权所有 鲁ICP备15010654号 版本号{{ versionNumber }}</p>
  </div>
</template>

<script>
import {defineComponent, ref, reactive, toRefs, onBeforeMount, getCurrentInstance} from 'vue'
import {useRouter} from "vue-router"
import {ElMessage} from 'element-plus'

export default {
  name: 'Login',
  setup() {
    let router = useRouter()
    let {proxy} = getCurrentInstance()
    let tabidx = ref(0)
    let codeimgSrc = ref('')
    let versionNumber = ref('') //版本号
    // 版本号
    let getVersionNumber = () => {
      let data = {
        postType: 'version',
      };
      proxy.$axios
          .postReq("/meide/REST/ajaxProperties", data)
          .then((res) => {
            if (res.success == "true") {
              versionNumber.value = res.VERSION
            } else {
              proxy.$alert(res.ErrorText, "提示", {
                confirmButtonText: "确定",
                callback: (action) => {
                },
              });
            }
          })
          .catch((error) => {
          });
    }
    // let codeimgBase = ref('/meide/GetImageNumber?temp=')
    // 验证码
    let refreshCode = () => {
      proxy.$axios.getReq('/meide/GetImageNumber?temp=' + new Date().getTime().toString(36), {})
          .then(res => {
            const myBlob = new window.Blob([res], {type: 'image/gif'})
            codeimgSrc.value = window.URL.createObjectURL(myBlob)
          })
          .catch(error => {
            // proxy.$alert(error, '提示', {
            //     confirmButtonText: '确定',
            //     callback: action => {}
            // });
          })
    }
    // 账号登录
    let userLogin = reactive({
      pnum: '',
      password: '',
      verify: '',
      uri: 'mdfront'
    })
    let onSubmitUser = () => {
      let data = {
        userid: userLogin.pnum,
        password: userLogin.password,
        numberCode: userLogin.verify,
        uri: userLogin.uri
      }
      proxy.$axios.postReq('/meide/loginCheck?temp=' + new Date().getTime().toString(36), data)
          .then(res => {
            if (res === 'ok') {
              // 获取用户信息
              let datauser = {
                postType: 'queryInfo',
                customerId: userLogin.pnum,
              }
              proxy.$axios.postReq('/meide/REST/QueryUserIdInfo', datauser)
                  .then(res => {
                    if (res.success == 'true') {
                      let storeData = JSON.stringify(res.data)
                      localStorage.setItem('userInfo', storeData)
                      router.push('/')
                    } else {
                      proxy.$alert('获取用户信息失败', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                        }
                      });
                    }
                  }).catch(error => {
                proxy.$alert(error, '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                });
              })
            } else {
              proxy.$alert(res, '提示', {
                confirmButtonText: '确定',
                callback: action => {
                }
              });
              window.URL.revokeObjectURL(codeimgSrc.value)
            }
          })
          .catch(error => {
            // proxy.$alert(error, '提示', {
            //     confirmButtonText: '确定',
            //     callback: action => {}
            // });
          })
    }
    // 短信登录
    let numLogin = reactive({
      pnumb: '',
      codeb: '',
    })
    let onSubmitNum = () => {

    }
    onBeforeMount(() => {
      getVersionNumber();
      proxy.$axios.getReq('/meide/GetImageNumber?temp=' + new Date().getTime().toString(36), {})
          .then(res => {
            const myBlob = new window.Blob([res], {type: 'image/jpeg'})
            codeimgSrc.value = window.URL.createObjectURL(myBlob)
          })
          .catch(error => {
            // proxy.$alert(error, '提示', {
            //     confirmButtonText: '确定',
            //     callback: action => {}
            // });
          })
    })
    return {
      versionNumber,
      getVersionNumber,
      codeimgSrc,
      // codeimgBase,
      refreshCode,
      tabidx,
      ...toRefs(userLogin),
      onSubmitUser,
      ...toRefs(numLogin),
      onSubmitNum,
    }
  }
}
</script>

<style lang="scss" scoped>
.top {
  padding: 30px 0;

  .flexbox {
    width: 1200px;
    margin: auto;
    justify-content: space-between;
    align-items: flex-end;
  }

  .logo {
    img {
      width: 190px;
    }
  }

  .tologin {
    font-size: 12px;

    a {
      font-size: 12px;
    }
  }
}

.loginmain {
  width: 100%;
  justify-content: space-between;
  height: 703px;
  padding-right: 260px;
  background: url(../../assets/img/loginbg.png) no-repeat;
  background-size: cover;

  .left {
  }

  .right {
    padding: 25px;
    background: #fff;
    border-radius: 5px;
    height: 421px;

    .tabtop {
      justify-content: space-around;
      margin-bottom: 30px;

      div {
        font-size: 16px;
        color: #999;
        cursor: pointer;
      }

      div.active {
        color: #F42434;
      }
    }

    .tabcon {
      .swp {
        margin-top: 15px;
        text-align: right;

        span, a {
          font-size: 12px;
          cursor: pointer;
        }
      }

      .swp span:hover, .swp a:hover {
        color: #F42434;
      }

      .inputbox {
        margin-top: 20px;

        ::v-deep(.el-input__inner) {
          width: 320px;
        }
      }

      .inputbox.flexbox {
        .code {
          width: 120px;
          height: 40px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        ::v-deep(.el-input__inner) {
          width: 150px;
        }
      ;
      }

      ::v-deep(.el-button) {
        height: 40px;
      }

      ::v-deep(.el-button--primary) {
        width: 100%;
        margin-top: 20px;
      }

      .loginway {
        margin-top: 30px;
        justify-content: flex-end;

        div {
          font-size: 12px;
          cursor: pointer;
        }

        a {
          font-size: 12px;
        }

        img {
          width: 16px;
          margin-right: 5px;
        }
      }

      .shortmsg {
        ::v-deep .el-button--primary {
          margin-top: 114px;
        }
      }
    }
  }
}

.footer {
  padding: 40px 0;

  p {
    text-align: center;
    color: #333;
  }
}
</style>
